export default __webpack_public_path__ + "static/media/WasherLogo.637f3556.png";